module.exports = __webpack_public_path__ + "static/media/galerija_2021 (14).504c15fd.jpg";